var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.badges.length
    ? _c(
        "div",
        { staticClass: "custom-field-badges" },
        _vm._l(_vm.badges, function (badge) {
          return _c(
            "span",
            {
              key: badge.key,
              staticClass: "custom-field-badge",
              style: badge.color
                ? {
                    backgroundColor: badge.color,
                    color: _vm.contrastTextColor(badge.color),
                  }
                : null,
            },
            [_vm._v("\n        " + _vm._s(badge.text) + "\n    ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }